import { Component } from '@angular/core';
import { DataSourceTable } from '@components/new-table/data-sources/data-source-table';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CustomersService } from '@services/data-source-tables/customers.service';
import { CustomersTableSettings } from '@/table-settings/tables/customers-table-settings';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { CustomerModel } from '@/models/tables/customer.model';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
})
export class CustomersComponent {
  displayedColumns = CustomersTableSettings.getColumnsSetting();
  dataSource = new DataSourceTable(this.customersService);
  reloadTrigger$ = new Subject<any>();

  constructor(
    private customersService: CustomersService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) {}

  /**
   * Gestisce il click sul pulsante dettagli per visualizzare i dettagli di un cliente BP
   * @param customer Cliente selezionato
   */
  btnDetailsClickFunction(customer: CustomerModel) {
    // TODO: Implementare navigazione ai dettagli del cliente quando sarà disponibile
    this.toastr.info('Funzionalità in sviluppo');
    // this.router.navigate([`/tables/customers/detail/${customer.id}`]);
  }

  /**
   * Gestisce il click sul pulsante elimina per cancellare un cliente BP
   * @param customer Cliente da eliminare
   */
  btnDeleteFunction(customer: CustomerModel) {
    const dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupDeletePopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteCustomer) => {
      if (deleteCustomer && customer.id) {
        this.customersService.deleteCustomer(customer.id).subscribe({
          next: () => {
            this.reloadTrigger$.next(1);
            this.toastr.success('Cliente BP cancellato correttamente!');
          },
          error: (error) => {
            this.toastr.error(`Errore durante la cancellazione del cliente BP.`);

            LoggerService.error('deleteCustomer failed!');
            LoggerService.error(error);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  /**
   * Configura il popup di conferma per l'eliminazione
   * @param dialogRef Riferimento al dialog
   */
  private setupDeletePopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questo cliente BP?';
    dialogRef.componentInstance.content =
      'Attenzione: una volta cancellato il cliente BP non sarà più possibile recuperarlo.';
    dialogRef.componentInstance.firstCTA = 'Si, cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }

  /**
   * Gestisce la creazione di un nuovo cliente BP
   * TODO: Implementare dialog per la creazione di un nuovo cliente
   */
  newCustomer() {
    this.toastr.info('Funzionalità in sviluppo');
    // TODO: Aprire dialog per inserimento nuovo cliente
    // Dopo il salvataggio, ricaricare la tabella
    // this.reloadTrigger$.next(1);
  }
}
